import React from "react";

function DropDownArrowIcon(props: { fill?: string; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 96 960 960"
      className={props.className}
      fill={props.fill}
    >
      <path d="M480 711 240 471l43-43 197 198 197-197 43 43-240 239Z" />
    </svg>
  );
}

export default DropDownArrowIcon;
